(ns frontend.ui.component.dropdown-button.view
  (:require
   ;; Official advised way to import individual Bootstrap components
   ;; instead of the entire library:
   ;; https://react-bootstrap.github.io/getting-started/introduction#importing-components
   ["react-bootstrap/Dropdown" :as Dropdown]
   ["react-bootstrap/DropdownButton" :as DropdownButton]
   [frontend.ui.component.button.style :as button-style]
   [frontend.ui.component.dropdown-button.style :as style]
   [herb.core :refer [<class]]))

(def ^:private DropdownItem (aget Dropdown "Item"))

(defn dropdown-button
  [{:keys [selected-value title on-change items]}]
  (let [selected-item (->> items
                           (filter (fn [item]
                                     (= (:value item) selected-value)))
                           (first))]
    [:> DropdownButton
     {:title     (or title 
                     (:label selected-item))

      :bs-prefix (<class button-style/button-dropdown {:variant :light})}
     (into
      [:div
       {:class (<class style/item-list)}]
      (for [item items]
        [:> DropdownItem
         {:href      "#"
          :bs-prefix (<class style/item)
          :on-click  #(on-change (:value item))}
         ;; Potential other use but watch-out: clicking on this `button` doesn't
         ;; close the `DropdownButton` menu (though it can be controlled with
         ;; `:show false`
         ;; :as       (r/reactify-component
         ;;            (partial button
         ;;                     {:variant :link
         ;;                      :on-click println}
         ;;                     "One"))}
         (:label item)]))]))
